<template>
    <div class="generalizeAgentClientMsg padding-20 bgc box-shadow">
        <div class="generalizeAgentMsg">
            <div class="imgName">
                <img :src="generalizeAgentMsg.headimageurl" alt="">
                <span>{{generalizeAgentMsg.name}}</span>
            </div>
            <div class="msg">
                <div>
                    <p><span>姓名：</span>{{generalizeAgentMsg.name}}</p>
                    <p><span>手机号：</span>{{generalizeAgentMsg.mobileno}}</p>
                </div>
                <div>
                    <p><span>直接推广笔数：</span>{{generalizeAgentMsg.totalordercount}}</p>
                    <p><span>直接推广金额：</span>{{generalizeAgentMsg.totalordermoney}}</p>
                </div>
                <div>
                    <p><span>上级推广员：</span>{{generalizeAgentMsg.parentname}}</p>
                    <p><span>加入时间：</span>{{generalizeAgentMsg.datetime}}</p>
                </div>
            </div>
        </div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="他的客户" name="HisClient">
                <HisClient :innerid="generalizeAgentMsg.innerid"></HisClient>
            </el-tab-pane>
            <el-tab-pane label="他的下级" name="HisSubordinate">
                <HisSubordinate :innerid="generalizeAgentMsg.innerid"></HisSubordinate>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import HisSubordinate from './components/generalizeAgentClientMsg/hisSubordinate'
import HisClient from './components/generalizeAgentClientMsg/hisClient'
import {mapGetters, mapActions} from 'vuex'
import {extensionAgentMsg} from '@/api/extensionAgent'
export default {
    name: 'generalizeAgentClientMsg',
    data() {
        return {
            generalizeAgentMsg: {},
            activeName: 'HisClient'
        }
    },
    created() {
        this.getExtensionAgentMsg()
    },
    methods: {
        getExtensionAgentMsg() {
            this.setLoading(true)
            extensionAgentMsg({
                data: {innerid: this.$route.query.innerid},
                success: data => {
                    this.generalizeAgentMsg = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        HisSubordinate, HisClient
    }
}
</script>
<style lang="scss">
    .generalizeAgentClientMsg{
        .el-tabs__header{
            margin-bottom: 30px !important;
        }
        .generalizeAgentMsg{
            .imgName{
                display: flex;
                img{
                    width: 50px;
                    height: 50px;
                }
            }
            .msg{
                display: flex;
                div{
                    flex: 1;
                    p{
                        line-height: 30px;
                        color: #303133;
                        span{
                            color: #9B9C9F;
                        }
                    }
                }
            }
        }
    }
</style>